module.exports = Em.Handlebars.compile("{{#each item in model}}\n    {{todo-list-item item=item}}\n{{/each}}\n");